import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const constApi = {
  // 分组活动码
  activity_code: baseAPI + baseUrl + 'official/event/code/list',
  // 轮次
  pk_round_list: baseAPI + baseUrl + 'official/event/pk/round/list',
  pk_round_create: baseAPI + baseUrl + 'official/event/pk/round/create',
  pk_round_create_batch: baseAPI + baseUrl + 'official/event/pk/round/batch_create',
  pk_round_update: baseAPI + baseUrl + 'official/event/pk/round/update',
  pk_round_del: baseAPI + baseUrl + 'official/event/pk/round/del',
  // 场次
  pk_session_list: baseAPI + baseUrl + 'official/event/pk/session/list',
  pk_session_create: baseAPI + baseUrl + 'official/event/pk/session/create',
  pk_session_create_batch: baseAPI + baseUrl + 'official/event/pk/session/batch_create',
  pk_session_update: baseAPI + baseUrl + 'official/event/pk/session/update',
  pk_session_del: baseAPI + baseUrl + 'official/event/pk/session/del',
  // 具体1v1场次
  pk_info_list: baseAPI + baseUrl + 'official/event/pk/info/list',
  pk_info_create: baseAPI + baseUrl + 'official/event/pk/info/create',
  pk_info_create_batch: baseAPI + baseUrl + 'official/event/pk/info/batch_create',
  pk_info_update: baseAPI + baseUrl + 'official/event/pk/info/update',
  pk_info_del: baseAPI + baseUrl + 'official/event/pk/info/del',
}

// 分组活动码
export const getActivityCode = async () => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.activity_code,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      group: 1
    }
  })
  return res
}

// pk轮次接口
export const getPkRound = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_round_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })

  return res
}

export const setPkRound = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.pk_round_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

export const delPkRound = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_round_del,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })

  return res
}

export const addPkRound = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.pk_round_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })

  return res
}

export const addPkRoundAll = async (params) => {
  console.log(store, params);
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_round_create_batch,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

// pk场次接口
export const getPkSession = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_session_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

export const setPkSession = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.pk_session_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

export const delPkSession = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_session_del,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

export const addPkSession = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.pk_session_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

export const addPkSessionAll = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.pk_session_create_batch,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 具体pk详情接口
export const getPkDetail = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_info_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

export const setPkDetail = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.pk_info_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

export const delPkDetail = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_info_del,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

export const addPkDetail = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.pk_info_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

export const addPkDetailAll = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.pk_info_create_batch,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

// 
